var _style, _rect, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuPumpHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.suPumpHead-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:15.1181;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 27.2,
    className: "suPumpHead-st0",
    width: 76.1,
    height: 33.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "suPumpHead-st0",
    d: "M66,48.4H14c-0.5,0-0.8-0.4-0.8-0.8v-7.2c0-0.5,0.4-0.8,0.8-0.8h52c0.5,0,0.8,0.4,0.8,0.8v7.2 C66.8,48,66.4,48.4,66,48.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "suPumpHead-st0",
    d: "M38.5,29.2l9.4-9.4c0.3-0.3,0.8-0.3,1.1,0l5.1,5.1c0.3,0.3,0.3,0.8,0,1.1l-5.9,5.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "suPumpHead-st0",
    cx: 40,
    cy: 44,
    r: 14.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuPumpHead);
export default __webpack_public_path__ + "static/media/suPumpHead.bbed9194f51192e2dffabefd79d4c0af.svg";
export { ForwardRef as ReactComponent };